import { Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@Component({
  selector: 'fury-toolbar-sidenav-mobile-toggle',
  templateUrl: './toolbar-sidenav-mobile-toggle.component.html',
  styleUrls: ['./toolbar-sidenav-mobile-toggle.component.scss'],
  imports: [FlexLayoutModule, MatIconModule],
})
export class ToolbarSidenavMobileToggleComponent {
  @Output() openSidenav = new EventEmitter();

  constructor() {}
}
